import React, {Component} from 'react';
import classNames from 'classnames';


export class Ribbon extends Component {
  classes() {
    return classNames('ribbon', this.props.position || 'left', this.props.color || 'default');
  }

  render() {
    return (
      <div className={this.classes()}>
        <a href={this.props.href}>
          {this.props.label}
        </a>
      </div>
    );
  }
}


export default Ribbon;



// WEBPACK FOOTER //
// ./src/components/Ribbon.js